import { render, staticRenderFns } from "./BuyListOld.vue?vue&type=template&id=9753586a&scoped=true&"
import script from "./BuyListOld.vue?vue&type=script&lang=js&"
export * from "./BuyListOld.vue?vue&type=script&lang=js&"
import style0 from "./BuyListOld.vue?vue&type=style&index=0&id=9753586a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9753586a",
  null
  
)

export default component.exports